import MuiGrid from './MuiGrid';
import { columns, rows } from './data';

const MuiGridProvider = () => {
  return (
    <div style={{ height: '600px' }}>
      <MuiGrid
        data={rows}
        loading={false}
        columns={columns}
        checkboxSelection
        disableRowClick
        onRowClick={(e) => console.log('cekiran red', e)}
        onRowDoubleClick={(e) => console.log('odabran red', e)}
      />
    </div>
  );
};

export default MuiGridProvider;
